module.exports = __webpack_public_path__ + "static/media/service3.ff8a7f9f.png";